import React, { useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  TablePagination,
  TableSortLabel,
  Box,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import {
  CustomMenu,
  CustomMenuItem,
  StyledTableCell,
} from "../../../../../styles/Shipmentstyles";
import EditIcon from "@mui/icons-material/Edit";
import { Vendor } from "../../../../../models/Vendors/Vendor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { Cancel } from "@mui/icons-material";
import { useStores } from "../../../use-stores";
import { useNotification } from "../../../../../utils/NotificationsContext";
import { EmployeeRoles } from "../../../../../models/Employees/EmployeeRoles";
import { HelperAPI } from "../../../api/HelperAPI";
interface VendorTableProps {
  vendors: Vendor[];
  maxHeight: number;
  limit: number;
  page_no: number;
  total_pages: number;
  total_count: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number,
  ) => void;
  onRowsPerPageChange: (limit: number) => void;
  sortBy: string;
  sortType: string;
  onSortChange: (column: string) => void;
}

const VendorTable: React.FC<VendorTableProps> = ({
  vendors,
  maxHeight,
  page_no,
  limit,
  total_count,
  onPageChange,
  onRowsPerPageChange,
  sortBy,
  sortType,
  onSortChange,
}) => {
  const theme = useTheme();
  const { vendorStore, userStore } = useStores();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);
  const [currentVendorId, setCurrentVendorId] = useState<number | null>(null);
  const { showError, showSuccess } = useNotification();

  const handleRowsChange = (value: number) => {
    onPageChange(null, 1);
    onRowsPerPageChange(value);
  };

  const handleRequestSort = (property: string) => {
    onSortChange(property);
  };
  const renderSortIcon = (property: string) => {
    if (sortBy === property) {
      return sortType === "ASC" ? "↑" : "↓";
    }
    return "↑↓";
  };

  const handleMenuClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    taskId: number,
  ) => {
    setAnchorEl(event.currentTarget);
    setCurrentVendorId(taskId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setCurrentVendorId(null);
  };

  const handleEdit = () => {
    handleMenuClose();
  };

  const handleDelete = () => {
    vendorStore
      .deleteVendor(currentVendorId!)
      .then(() => {
        showSuccess("Vendor deleted successfully");
      })
      .catch((err) => {
        showError(
          "Error occurred",
          err?.response?.data?.message ||
            "Something went wrong! Please try again later.",
        );
      });
    handleMenuClose();
  };

  const handleDownloadLink = (url: string, defaultFilename: string | null) => {
    if (!url?.trim()) return;
    HelperAPI.downloadVendorFiles(url, defaultFilename).catch((err) => {
      showError(
        "Download failed",
        err?.response?.data?.message || "Failed to download file",
      );
    });
  };

  // const getApprovalStatus = (vendor: Vendor) => {
  //   const financeApproved = vendor.finance_approval === 1;
  //   const financeRejected = vendor.finance_rejection === 1;
  //   const sourcingApproved = vendor.sourcing_approval === 1;
  //   const sourcingRejected = vendor.sourcing_rejection === 1;

  //   if (financeRejected || sourcingRejected) {
  //     return {
  //       status: "rejected",
  //       icon: <Cancel sx={{ color: theme.palette.error.main }} />,
  //       tooltip: "Rejected",
  //     };
  //   }

  //   if (financeApproved && sourcingApproved) {
  //     return {
  //       status: "approved",
  //       icon: <CheckCircle sx={{ color: theme.palette.success.main }} />,
  //       tooltip: "Approved",
  //     };
  //   }

  //   return {
  //     status: "pending",
  //     icon: <Pending sx={{ color: theme.palette.warning.main }} />,
  //     tooltip: "Pending",
  //   };
  // };

  return (
    <>
      <Paper
        sx={{
          marginTop: "1rem",
          padding: "1.5rem",
          paddingLeft: "0",
          overflow: "hidden",
          borderRadius: "4px",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <TableContainer sx={{ maxHeight: maxHeight }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell
                  sx={{
                    padding: "6px 12px",
                    position: "sticky",
                    left: 0,
                    zIndex: 12,
                    boxShadow: "10px 0 20px -12px rgba(115,115,115,0.3);",
                  }}
                >
                  <TableSortLabel
                    onClick={() => handleRequestSort("id")}
                    IconComponent={() => <span>{renderSortIcon("id")}</span>}
                  >
                    ID
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell
                  sx={{
                    padding: "6px 12px",
                    textAlign: "center",
                    fontSize: "14px",
                    zIndex: 10,
                  }}
                >
                  Name
                </StyledTableCell>
                <StyledTableCell
                  sx={{
                    padding: "6px 12px",
                    textAlign: "center",
                    fontSize: "14px",
                  }}
                >
                  Vendor Type
                </StyledTableCell>
                <StyledTableCell
                  sx={{
                    padding: "6px 12px",
                    textAlign: "center",
                    zIndex: 10,
                    fontSize: "14px",
                  }}
                >
                  GST No.
                </StyledTableCell>
                {/* <StyledTableCell
                  sx={{
                    padding: "6px 12px",
                    textAlign: "center",
                    zIndex: 10,
                    fontSize: "14px",
                  }}
                >
                  Approval
                </StyledTableCell> */}
                <StyledTableCell
                  sx={{
                    padding: "6px 12px",
                    textAlign: "center",

                    zIndex: 10,
                    fontSize: "14px",
                  }}
                >
                  GST Certificate
                </StyledTableCell>
                <StyledTableCell
                  sx={{
                    padding: "6px 12px",
                    textAlign: "center",

                    zIndex: 10,
                    fontSize: "14px",
                  }}
                >
                  PAN Card
                </StyledTableCell>
                <StyledTableCell
                  sx={{
                    padding: "6px 12px",
                    textAlign: "center",
                    zIndex: 10,
                    fontSize: "14px",
                  }}
                >
                  Bank Account
                </StyledTableCell>
                <StyledTableCell
                  sx={{
                    padding: "6px 12px",
                    textAlign: "center",
                    zIndex: 10,
                    fontSize: "14px",
                  }}
                >
                  <TableSortLabel
                    onClick={() => handleRequestSort("created_date")}
                    IconComponent={() => (
                      <span>{renderSortIcon("created_date")}</span>
                    )}
                  >
                    Created Date
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell
                  sx={{
                    padding: "6px 12px",
                    textAlign: "center",
                    zIndex: 10,
                    fontSize: "14px",
                  }}
                >
                  <TableSortLabel
                    onClick={() => handleRequestSort("modified_date")}
                    IconComponent={() => (
                      <span>{renderSortIcon("modified_date")}</span>
                    )}
                  >
                    Modified Date
                  </TableSortLabel>
                </StyledTableCell>
                {userStore.hasPermission(EmployeeRoles.EDIT_VENDORS) && (
                  <StyledTableCell
                    sx={{
                      padding: "6px 12px",
                      textAlign: "center",
                      verticalAlign: "middle",
                      fontSize: "14px",
                    }}
                  >
                    Actions
                  </StyledTableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {vendors?.map((vendor, index) => (
                <TableRow
                  key={index}
                  hover
                  sx={{
                    "&:hover": {
                      backgroundColor: theme.palette.grey[200],
                    },
                  }}
                >
                  <TableCell
                    sx={{
                      fontSize: "16px",
                      position: "sticky",
                      left: 0,
                      zIndex: 10,
                      boxShadow: "10px 0 20px -12px rgba(115,115,115,0.3);",
                      backgroundColor: `${theme.palette.background.paper}`,
                    }}
                  >
                    {vendor.id}
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    {vendor?.name!?.toLocaleLowerCase()}
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    {Array.isArray(vendor?.types) && vendor.types.length > 0
                      ? vendor?.types?.map((type, i) =>
                          i !== vendor?.types!?.length - 1
                            ? type.type + ", "
                            : type.type + "",
                        )
                      : "--"}
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    {vendor.gst_number}
                  </TableCell>
                  {/* <TableCell
                    sx={{
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    <Tooltip title={getApprovalStatus(vendor).tooltip}>
                      {getApprovalStatus(vendor).icon}
                    </Tooltip>
                  </TableCell> */}
                  <TableCell
                    sx={{
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faDownload}
                      onClick={() =>
                        handleDownloadLink(
                          vendor.gstin_certificate_link!,
                          `GST_Certificate_${vendor.id}.pdf`,
                        )
                      }
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faDownload}
                      onClick={() =>
                        handleDownloadLink(
                          vendor.pan_card_link!,
                          `PAN_Card_${vendor.id}.pdf`,
                        )
                      }
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faDownload}
                      onClick={() =>
                        handleDownloadLink(
                          vendor.bank_details_link!,
                          `Bank_Details_${vendor.id}.pdf`,
                        )
                      }
                    />
                  </TableCell>

                  <TableCell
                    sx={{
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    {vendor.created_date
                      ? new Date(vendor.created_date!).toLocaleDateString(
                          "en-GB",
                          {
                            day: "numeric",
                            month: "numeric",
                            year: "numeric",
                          },
                        )
                      : "-"}
                  </TableCell>

                  <TableCell
                    sx={{
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    {vendor.modified_date
                      ? new Date(vendor.modified_date!).toLocaleDateString(
                          "en-GB",
                          {
                            day: "numeric",
                            month: "numeric",
                            year: "numeric",
                          },
                        )
                      : "-"}
                  </TableCell>
                  {userStore.hasPermission(EmployeeRoles.EDIT_VENDORS) && (
                    <TableCell
                      sx={{
                        padding: "8px",
                        fontSize: "16px",
                        textAlign: "center",
                      }}
                    >
                      <IconButton
                        size="small"
                        onClick={(event) => handleMenuClick(event, vendor.id!)}
                      >
                        <MoreVertIcon fontSize="small" />
                      </IconButton>
                      <CustomMenu
                        anchorEl={anchorEl}
                        open={isOpen}
                        onClose={handleMenuClose}
                        anchorOrigin={{ vertical: "top", horizontal: "left" }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                      >
                        <CustomMenuItem onClick={() => handleEdit()}>
                          <Link
                            to={`/vendors/add-edit-vendor?vendor-id=${currentVendorId}`}
                            style={{ textDecoration: "none", color: "black" }}
                          >
                            <EditIcon fontSize="small" /> Edit
                          </Link>
                        </CustomMenuItem>
                        <CustomMenuItem onClick={() => handleDelete()}>
                          <Cancel fontSize="small" />
                          Delete
                        </CustomMenuItem>
                      </CustomMenu>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {vendors?.length === 0 && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="10rem"
            textAlign="center"
          >
            <Typography variant="h6" fontWeight="500" color="text.secondary">
              No data found
            </Typography>
          </Box>
        )}

        <TablePagination
          rowsPerPageOptions={[30, 50, 100, 150, 200]}
          component="div"
          count={total_count}
          page={page_no - 1}
          rowsPerPage={limit}
          onPageChange={(event, page_no) => onPageChange(event, page_no + 1)}
          onRowsPerPageChange={(e) =>
            handleRowsChange(parseInt(e.target.value, 10))
          }
          sx={{
            padding: "0.5rem",
          }}
        />
      </Paper>
    </>
  );
};

export default VendorTable;
